import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { AuthService } from '../_services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionAnswerService } from '../_services/question-answer.service';
import { QuestionAnswer } from '../_models/question-answer';

@Component({
  selector: 'app-question-answer-list',
  templateUrl: './question-answer-list.component.html',
  styleUrls: ['./question-answer-list.component.css']
})
export class QuestionAnswerListComponent implements OnInit {


  questionAnswerList: QuestionAnswer[] = [];

  displayedColumns = ['questionName','optionOne','optionTwo','optionThree','optionFour','answer','action'];
  questionAnswerDataSource = new MatTableDataSource<QuestionAnswer>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private snotifyService: SnotifyService,
    private questionAnswerService: QuestionAnswerService,
  ) {
  }

  ngOnInit() {
    this.getQuestionAnswerList();
  }

  getQuestionAnswerList() {

    this.questionAnswerService.getQuestionAnwerList().subscribe(
      resp => {
        this.questionAnswerList = resp as QuestionAnswer[];
        this.questionAnswerDataSource = new MatTableDataSource<QuestionAnswer>(this.questionAnswerList);
        this.questionAnswerDataSource.paginator = this.paginator;
      }, error => {
        console.log(error);
        this.snotifyService.error(error);
      })
  }



  deleteQuestionAnswer(questionAnswerDataForm: QuestionAnswer) {
    if (confirm("Are you sure you want to delete ")) {
      this.questionAnswerService.deleteQuestionAnswer(questionAnswerDataForm).subscribe(
        resp => {
        this.getQuestionAnswerList();
       }, error => {
         console.log(error);
         this.snotifyService.error(error);
       })
    }
   
   }





}
